export default __webpack_public_path__ + "static/media/round-vip-arrow.a1eab39a.svg";